import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import Icon from '../../Icon';
import styles from './index.styl';

export function DocumentView({
  title,
  accent,
  pointer,
  onClick,
  subtitle,
  onDelete,
  className,
  showButton,
  additionalClass,
}) {
  return (
    <div className={cn(styles.wrapper, additionalClass)}>
      <div
        className={cn(styles.infoWrapper, { [styles.pointer]: pointer })}
        onClick={onClick}
      >
        <Icon name="icon-document-black" size={32} className={styles.icon} />
        <div className={styles.info}>
          <div
            className={cn(
              styles.title,
              { [styles.titleAccent]: accent },
              className,
            )}
          >
            {title}
          </div>
          <If condition={subtitle}>
            <div className={styles.subtitle}>{subtitle}</div>
          </If>
        </div>
      </div>
      {showButton && (
        <Icon
          name="remove-member"
          size={16}
          className={styles.removeIcon}
          onClick={onDelete}
        />
      )}
    </div>
  );
}

DocumentView.defaultProps = {
  additionalClass: 'mb3',
};

DocumentView.propTypes = {
  pointer: PropTypes.bool,
  title: PropTypes.string,
  onClick: PropTypes.func,
  subtitle: PropTypes.string,
  onDelete: PropTypes.func,
  showButton: PropTypes.bool,
  accent: PropTypes.bool,
  className: PropTypes.string,
  additionalClass: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/common/DocumentView/index.jsx